import styled from 'styled-components';

export const Container = styled.div``;

export const AddendumNotFound = styled.span`
  font-size: 18px;

  button {
    font-weight: bold;
    background: transparent;
    border: none;
    font-weight: bold;
    text-decoration: underline;
    color: #808080;
    outline: unset !important;
  }

  span {
    display: block;
  }
`;
